import NiceModal from '@ebay/nice-modal-react';
import { ActionIcon, Tooltip } from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';

import { useRefreshFbPageToken } from '../../../../api/refreshFbPageToken';
import { InstPage } from '../../../../types';

import { ConfirmModal } from '@/components/Modals/Confirm';

export const RefreshToken = ({ page }: { page: InstPage }) => {
  const refreshFbPageToken = useRefreshFbPageToken();

  return (
    <ActionIcon
      variant="filled"
      disabled={refreshFbPageToken.isLoading}
      onClick={() => {
        NiceModal.show(ConfirmModal, {
          title: `Refresh FB token for (${page.name})?`,
          onSuccess: () => refreshFbPageToken.mutate({ pageId: page._id }),
        });
      }}
      radius="md"
    >
      <Tooltip label="Refresh FB token">
        <IconRefresh size={20} />
      </Tooltip>
    </ActionIcon>
  );
};
